import React from 'react';
import './DeleteModal.css';

interface DeleteCategoryModalProps {
    isOpen: boolean;
    categoryName: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const DeleteCategoryModal: React.FC<DeleteCategoryModalProps> = ({ isOpen, categoryName, onConfirm, onCancel }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onCancel}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <h2>Delete Category</h2>
                <p>Are you sure you want to delete the category "{categoryName}"? All tasks in this category will become uncategorized.</p>
                <div className="modal-buttons">
                    <button className="modal-btn cancel-btn" onClick={onCancel}>Cancel</button>
                    <button className="modal-btn confirm-btn" onClick={onConfirm}>Delete</button>
                </div>
            </div>
        </div>
    );
}; 